import { useEffect, useState } from 'react'

import type { ApiResponse } from '../types/api'
import { api } from '../utils/api-client'

interface PlatformInfo {
  download_link: string
  version: string
}

interface DownloadLinks {
  android: PlatformInfo
  google_play_android: PlatformInfo
  ios: PlatformInfo
}

const useAppDownload = () => {
  const [downloadLinks, setDownloadLinks] = useState<DownloadLinks>({
    android: {
      download_link: '',
      version: '',
    },
    google_play_android: {
      download_link: '',
      version: '',
    },
    ios: {
      download_link: '',
      version: '',
    },
  })

  useEffect(() => {
    const checkForUpdate = async () => {
      const updateRes = await api.post<ApiResponse<DownloadLinks>>(
        '/ajax_datav2.php',
        {
          type: 'get_app_version',
        },
      )
      const { status, info } = updateRes.data
      if (status === 1) {
        setDownloadLinks(info)
      }
    }
    checkForUpdate()
  }, [])

  return downloadLinks
}

export default useAppDownload
